module.exports = __webpack_public_path__ + "static/img/6.aa6ec1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/eng/6.png
// module id = /jeP
// module chunks = 0